import { takeEvery, put, call, take, select } from 'redux-saga/effects'
import store from '../store'
import {
  LOAD_PROFILE_START,
  UPDATE_PROFILE,
  GET_PROFESSION,
  API_SERVER,
  GET_FIELD_OF_WORK,
  SAVE_LOGO,
  GET_LOGO,
  DELETE_LOGO,
  MAX_LOGO_HEIGHT,
  MAX_LOGO_WIDTH,
  UPDATE_USER_EMAIL,
  VERIFY_USER_PROFILE,
  IDENTIFICATION_SERVER
} from '../constants'
import {
  apiManualPost,
  apiManualRequest,
  createUploadFileChannel
} from '../utils/request'
import { propertyArray } from '../utils/invoice.utils'
import {
  loadProfileSuccess,
  loadProfileFailed,
  getProfessionSuccess,
  getProfessionFailed,
  updateProfileSuccess,
  updateProfileFailed,
  closeInvoiceReviewSnackBar,
  getFieldOfWorkSuccess,
  updateTaxCard,
  ssnDuplicate,
  saveLogoSuccess,
  saveLogoFailed,
  getLogoSuccess,
  deleteLogoSuccess,
  deleteLogoFailed,
  updateUserEmailSuccess,
  updateUserEmailFailed
} from '../actions'
import { updateFormValues } from '../form'

import { resizeImage } from '../utils/resizeImage'
import {
  getLoggedInEmail,
  getTaxCardData,
  getUserType,
  getUuid
} from '../selectors/client.selector'

function* loadProfileSaga({ data }) {
  const selectedUser = data
  try {
    const uuid = store.getState().client.user.data[2]
    const userType = store.getState().client.user.data[5]
    if (!!uuid) {
      const url = `${API_SERVER}/GetUserContactDetails`

      const body = JSON.stringify({
        uuid: userType == 2 ? selectedUser.uuid : uuid
      })
      const result = yield call(apiManualPost, url, body)
      const resultParsed = JSON.parse(result.data)
      yield put(loadProfileSuccess(resultParsed))
      yield put(updateFormValues('profile', resultParsed))
    }
  } catch (e) {
    yield put(loadProfileFailed(e))
  }
}

function* updateProfileSaga({ formValues }) {
  try {
    const uuid = store.getState().client.user.data[2]
    const taxCardData = yield select(getTaxCardData)

    const userType = store.getState().client.user.data[5]
    const { adminUser } = store.getState()
    const { selectedUser } = adminUser

    const userInfo = store.getState().profile.userData
    const url = `${API_SERVER}/UpdateUserContactDetails`

    let bankRef = formValues.account_number
    let res = bankRef.substring(0, 2)
    if (res === 'fi' || res === 'Fi' || res === 'fI') {
      bankRef = bankRef.replace(res, 'FI')
    }

    const formBody = {
      uuid: userType == 2 ? selectedUser.uuid : uuid,
      firstname: formValues.firstname,
      lastname: formValues.lastname,
      ssn: formValues.ssn,
      phone: formValues.phone,
      email: formValues.email,
      account_number: bankRef,
      salary_payment_option: formValues.salary_payment_option,
      //salary_payment_option: 'manual_pay',
      address: formValues.address,
      zip_code: formValues.zip_code,
      city: formValues.city,
      market_name: formValues.market_name,
      useMarketName: formValues.useMarketName,
      job_title: formValues.job_title,
      field_work: formValues.field_work
    }

    //Must pass all properties returned by GetUserContactDetails API call.
    //UpdateUserContactDetails will otherwise update those values with incorrect
    //values. API should instead handle user and admin updates to profile info
    //differently.
    const body = { ...userInfo, ...formBody }

    const result = yield call(apiManualPost, url, JSON.stringify(body))

    if (result.data === 'User contact information updated successfully!') {
      let getUrl = `${API_SERVER}/GetUserContactDetails`
      let getBody = JSON.stringify({
        uuid: userType == 2 ? selectedUser.uuid : uuid
      })
      let getResult = yield call(apiManualPost, getUrl, getBody)
      let getResultParsed = JSON.parse(getResult.data)
      yield put(updateProfileSuccess(getResultParsed))
      yield put(updateTaxCard(taxCardData, true))

      //If there is no industry tax card sent,
      //update industry tax card after profile is updated
      // KAS-335
      const basicInfoUrl = `${API_SERVER}/GetUserDetailsTaxID`

      const basicInfoResult = yield call(apiManualPost, basicInfoUrl, getBody)
      const basicInfoResultParse = JSON.parse(basicInfoResult.data)

      if (basicInfoResultParse.path == undefined) {
        yield put(updateFormValues('taxArea', basicInfoResultParse))
      } else {
        null
      }
      // end update industry tax card part (KAS-335)
    } else if (result.data === 'ssn already exist') {
      // KAS-361 SSN duplicated
      yield put(ssnDuplicate(result.data))
    } else {
      yield put(updateProfileFailed())
    }
    //Fix:: Initial SaveInvoiceDraft, resetting flags
    yield put(closeInvoiceReviewSnackBar())
  } catch (e) {
    // console.warn(e)
  }
}

function* getProfessionSaga() {
  try {
    const professionUrl = `${API_SERVER}/GetProffession`
    const professionResult = yield apiManualRequest(professionUrl)
    const parRes = JSON.parse(professionResult.data)
    const parsedResult = propertyArray(parRes, 'profession')
    if (parsedResult) yield put(getProfessionSuccess(parsedResult))
  } catch (e) {
    yield put(getProfessionFailed(e))
  }
}

function* getFieldOfWorkSaga() {
  try {
    const url = `${API_SERVER}/GetFieldOfWork`
    const result = yield apiManualRequest(url)
    yield put(getFieldOfWorkSuccess(result.data))
  } catch (error) {}
}

function* saveLogoSaga({ file }) {
  try {
    if (file) {
      const resizedFile = yield call(
        resizeImage,
        file,
        MAX_LOGO_WIDTH,
        MAX_LOGO_HEIGHT
      )
      const uuid = store.getState().client.user.data[2]
      const userType = store.getState().client.user.data[5]
      const { adminUser } = store.getState()
      const { selectedUser } = adminUser

      const url = `${API_SERVER}/AddLogo`

      const body = {
        uuid: userType == 2 ? selectedUser.uuid : uuid,
        filename: resizedFile.name,
        filetype: resizedFile.type
      }

      const channel = yield call(
        createUploadFileChannel,
        url,
        resizedFile,
        body,
        uuid
      )
      while (true) {
        const { progress = 0, err, success, data } = yield take(channel)
        if (err) {
          yield put(saveLogoFailed())
        }
        if (success) {
          yield put(saveLogoSuccess(JSON.parse(data)))
        }
        console.log(progress)
      }
    } else {
      yield put(saveLogoFailed())
    }
  } catch (e) {
    yield put(saveLogoFailed())
  }
}

function* getLogoSaga({ data }) {
  try {
    const uuid = store.getState().client.user.data[2]
    const userType = store.getState().client.user.data[5]
    const selectedUser = data

    if (uuid) {
      const url = `${API_SERVER}/GetLogo`
      const body = {
        uuid: userType == 2 ? selectedUser.uuid : uuid
      }
      const result = yield call(apiManualPost, url, JSON.stringify(body))
      yield put(getLogoSuccess(result.data))
    }
  } catch (e) {}
}

function* deleteLogoSaga() {
  try {
    const uuid = store.getState().client.user.data[2]
    const logo = store.getState().logo.logo

    const url = `${API_SERVER}/DeleteLogo`
    const body = {
      logo_id: logo.logo_id,
      uuid: uuid,
      path: logo.path
    }
    const result = yield call(apiManualPost, url, JSON.stringify(body))
    if (result.data === 'Logo deleted successfully!')
      yield put(deleteLogoSuccess())
    else yield put(deleteLogoFailed())
  } catch (e) {
    yield put(deleteLogoFailed())
  }
}

function* updateUserEmailSaga({ values }) {
  try {
    const uuid = yield select(getUuid)
    const loggedInEmail = yield select(getLoggedInEmail)
    const userType = yield select(getUserType)
    const { adminUser } = store.getState()
    const { selectedUser } = adminUser

    const url = `${API_SERVER}/UpdateUserEmail`

    const body = {
      uuid: userType == 2 ? selectedUser.uuid : uuid,
      oldEmail: userType == 2 ? selectedUser.email : loggedInEmail, // old email
      email: values.new_email // new email
    }

    const result = yield call(apiManualPost, url, JSON.stringify(body))

    if (result.data === 'User email updated successfully') {
      yield put(updateUserEmailSuccess(result.data))
      sessionStorage.clear()
    } else {
      yield put(updateUserEmailFailed(result.data))
    }
  } catch (error) {
    yield put(updateUserEmailFailed(error))
  }
}

function* verifyUserProfile() {
  try {
    const uuid = yield select(getUuid)
    const url = `${IDENTIFICATION_SERVER}/?uuid=${uuid}`
    window.location.href = url
  } catch (error) {
    throw error
  }
}

export function* watchGetFieldOfWork() {
  yield takeEvery(GET_FIELD_OF_WORK, getFieldOfWorkSaga)
}

export function* watchLoadProfileSaga() {
  yield takeEvery(LOAD_PROFILE_START, loadProfileSaga)
}

export function* watchUpdateProfileSaga() {
  yield takeEvery(UPDATE_PROFILE, updateProfileSaga)
}

export function* watchGetProfession() {
  yield takeEvery(GET_PROFESSION, getProfessionSaga)
}

export function* watchSaveLogoSaga() {
  yield takeEvery(SAVE_LOGO, saveLogoSaga)
}

export function* watchGetLogoSaga() {
  yield takeEvery(GET_LOGO, getLogoSaga)
}

export function* watchDeleteLogoSaga() {
  yield takeEvery(DELETE_LOGO, deleteLogoSaga)
}
export function* watchUpdateUserEmailSaga() {
  yield takeEvery(UPDATE_USER_EMAIL, updateUserEmailSaga)
}
export function* watchVerifyUserProfile() {
  yield takeEvery(VERIFY_USER_PROFILE, verifyUserProfile)
}
